import { ArrowRight, Info } from "@phosphor-icons/react";

import { Tag } from "common/components/ui/Tag";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";

export default function VariablesTable({ variables }: { variables: string[] }) {
  return (
    <div className="rounded-3xl border border-black-150 mt-2.5">
      <table className="w-full table-fixed">
        {/* Header */}
        <thead className="block">
          <tr className="table w-full table-fixed border-b border-black-150">
            <th className="px-3 py-2 text-left align-middle">
              <div className="flex items-center text-button-xs text-black-500">
                CSV column
              </div>
            </th>
            <th className="px-3 py-2 text-left align-middle w-3/5">
              <div className="flex items-center gap-x-1 text-button-xs text-black-500 pl-8">
                Variable
                <Tooltip>
                  <TooltipTrigger>
                    <Info size={16} weight="fill" className="text-black-300" />
                  </TooltipTrigger>
                  <TooltipContent>
                    The columns from the uploaded file will be usable as
                    variables in the campaign. You must select the identifier
                    column containing LinkedIn URLs
                  </TooltipContent>
                </Tooltip>
              </div>
            </th>
          </tr>
        </thead>

        {/* Variables */}
        <tbody className="block max-h-58 overflow-y-auto scrollbar-thin">
          {variables.map((variable) => (
            <tr
              key={variable}
              className="table w-full table-fixed border-b border-black-150 last:border-b-0"
            >
              <td className="px-2.5 py-3 align-middle text-button-sm text-black-900">
                {variable}
              </td>
              <td className="px-2.5 py-3 align-middle w-3/5">
                <div className="flex items-center gap-x-4">
                  <ArrowRight className="size-4 text-black-200" />
                  <Tag variant="info" className="w-fit">
                    {variable}
                  </Tag>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
